import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { TypedBulletList } from '../interactions/TypedBulletList.jsx'

const TYPE_OPTIONS = [
  { id: 'unblock', label: 'unblock', tone: 'moss' },
  { id: 'decide',  label: 'decide',  tone: 'clay' },
  { id: 'support', label: 'support', tone: 'berry' },
  { id: 'context', label: 'context', tone: 'mustard' },
]

/**
 * AsksCard — typed bullet list (unblock / decide / support / context).
 * catalog #7, prep-asks. Shape-shift from chip-multi-context to typed bullet list.
 */
export function AsksCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []
  const hasBullets = items.some((i) => i.text)

  return (
    <CardFrame
      kind="prep"
      icon="⊕"
      iconClass="moss"
      title="Asks for your manager"
      prompt="What do you need from them?"
      state={disabled ? 'locked' : hasBullets ? 'filled' : 'empty'}
      data-testid="prep-card-prep-asks"
      className="prepcard"
    >
      <TypedBulletList
        items={items}
        onChange={onChange}
        typeOptions={TYPE_OPTIONS}
        maxItems={10}
        maxChars={140}
        placeholder="Something you need…"
        disabled={disabled}
        required
      />
    </CardFrame>
  )
}
